<ng-container *ngIf="list$ | async as list">
  <div class="d-flex align-items-center">
    <div [ngClass]="{ 'campaign-list__dropdown-wrapper': true, 'campaign-list__dropdown-wrapper--icon': !!selected.value }">
      <mdb-form-control class="form-select form-fill dropdownClassTheme mb-0" [ngClass]="selectClass">
        <mdb-select class="mdb-select mdb-select--hidden-input" [formControl]="selected"  (valueChange)="onSelect($event)" (opened)="addClass()" (closed)="removeClass()" (click)="onClick($event, select)" #select>
          <mdb-option *ngFor="let option of list" [value]="option" [ngClass]="theme" class="select-option select-option--text-truncate">
            {{option.name}}
          </mdb-option>
          <div class="select-custom-content d-none"></div>
        </mdb-select>
        <label mdbLabel class="form-label text-truncate">{{getDropdownToggleLabel()}}</label>
        <ng-container *ngIf="selected.value" class="">
          <ng-container [ngSwitch]="selected.value.type">
            <app-icon-auction *ngSwitchCase="4" class="dropdown__icon dropdown__icon--mdb "></app-icon-auction>
            <app-icon-donation *ngSwitchCase="0" class="dropdown__icon dropdown__icon--mdb "></app-icon-donation>
            <app-icon-last-hero *ngSwitchCase="9" class="dropdown__icon dropdown__icon--mdb "></app-icon-last-hero>
          </ng-container>
        </ng-container>
      </mdb-form-control>
    </div>
  </div>
</ng-container>
